var app;

app = window.App || (window.App = {});

app.Invoices = {
  recalculate: function() {
    var form, formData, serialized;
    form = document.querySelector('form[data-group]');
    if (!form) {
      return;
    }
    formData = new FormData(form);
    serialized = new URLSearchParams(formData).toString();
    return $.ajax({
      url: form.dataset['group'] + "/invoices/recalculate/new?" + serialized
    });
  },
  setup: function() {
    document.querySelectorAll('form #invoice_items_fields input[data-recalculate]').forEach(function(input) {
      return input.addEventListener('input', app.Invoices.recalculate);
    });
    return document.addEventListener("rails-nested-form:remove", app.Invoices.recalculate);
  }
};

document.addEventListener("turbo:load", app.Invoices.setup);

document.addEventListener("rails-nested-form:add", app.Invoices.setup);
